module.exports = __webpack_public_path__ + "img/Tinker.ef280fc7.png";